import { useNavigate } from 'react-router-dom';
import type { DashboardInsight } from '@/utils/dashboard';

export default function AiInsightsPanel({ insights }: { insights: DashboardInsight[] }) {
  const navigate = useNavigate();
  return (
    <div className="p-5">
      <div className="flex items-center gap-2 rounded-md bg-accent-50 px-3 py-2">
        <span className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-500 text-background-50 text-sm">
          <i className="ri-sparkling-2-line" />
        </span>
        <p className="text-xs text-accent-800">
          Generated from live campaign, delivery and payment signals.
        </p>
      </div>
      <div className="mt-3 grid grid-cols-1 gap-3 lg:grid-cols-3">
        {insights.map((insight) => (
          <div
            key={insight.id}
            className="rounded-md border border-background-200 bg-background-50 p-3.5"
          >
            <p className="text-sm font-medium text-foreground-950">{insight.title}</p>
            <p className="mt-1 text-xs leading-relaxed text-foreground-600">{insight.body}</p>
            <button
              type="button"
              onClick={() => navigate(insight.link)}
              className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary-700 cursor-pointer hover:text-primary-800"
            >
              {insight.cta}
              <i className="ri-arrow-right-line text-[13px]" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}